import {AxiosError} from 'axios'
import {useQuery} from 'react-query'

import {API} from '../../networking/http'

// A venue's own cancellation policy as a customer may read it (server: publicPolicyView). `rules` are the
// windows before the start, widest first; outside every window `defaultRefundPercent` is returned.
export type PublicCancelPolicy = {
  id: string
  name: string
  customerSummary: string | null
  freeCancelHours: number | null
  defaultRefundPercent: number | null
  rules?: {withinHours: number; refundPercent: number}[]
}

export const makeGetPublicCancelPolicyEndpoint = (venueId: string, policyId: string) =>
  `venues/${venueId}/cancel-policies/${encodeURIComponent(policyId)}/public`

// Null when there is no policy to read, or the server does not know it (404: another venue's, deleted).
export const usePublicCancelPolicy = (venueId?: string | null, policyId?: string | null) =>
  useQuery<PublicCancelPolicy | null, AxiosError>(
    ['getPublicCancelPolicy', {venueId, policyId}],
    () =>
      API.get<unknown, {item: PublicCancelPolicy}>(makeGetPublicCancelPolicyEndpoint(venueId!, policyId!))
        .then((res) => res.data?.item ?? null)
        .catch((err: AxiosError) => {
          if (err?.response?.status === 404) {
            return null
          }
          throw err
        }),
    {enabled: Boolean(venueId && policyId), staleTime: 1000 * 60 * 5, refetchOnWindowFocus: false, retry: false},
  )
